module.exports = __webpack_public_path__ + "static/media/registration-screen-graphic.46d4a930.png";